export const quotation_terms = ["GST at 18% will be applicable.",
    "The price provided is Ex-Mill price hence loading & Transportation charges at buyer scope.",
    "Delivery time 4-5 weeks from the date advance payment received.",
    "Payment Terms: 70% advance along with Purchase order and 30% before dispatch against Performa-invoice.",
    "* Warranty for the above-mentioned machine is for one year.",
    "* Warranty will not be applicable for electronics and easily breakable parts.",
    "Transport, food & accommodation to the service engineer should be provided by the customer.",
    "Transit & Insurance from Factory to customer place is extra.",
    "Packing and erection charges free.",
    "Unloading charges at the customer factory should be paid by the customer.",
    "Advance payment once received is not refundable.",
    "This quotation is valid for 15 days from the date mentioned above.",
    "Anything legally related to this is determined at the court in Coimbatore and no other courts"]

export const po_terms = ["GST at 18% will be applicable.",
    "50% advance, 50% at the time of dispatch.",
    "Debit charges will be applicable in case of any delay from beyond delivery schedule.",
    "Packing should be safe and it is the supplier's responsibility & in case of any transit damage that's the supplier's responsibility.",
    "1-year warranty - any problem during this period must be rectified by the supplier at no extra cost.",
    "If any issue arises due to use of non-branded/low-quality materials, the supplier will bear the debit/penalty.",
    "Anything legally related to this is determined by the court in Coimbatore and no other courts."]

export const screens = [
  {
    "name": "Dashboard",
    "type": "home",
    "screen": "dashboard",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Roles",
    "type": "home",
    "screen": "roles",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Users",
    "type": "home",
    "screen": "users",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Vendors",
    "type": "vendor",
    "screen": "vendor",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Suppliers",
    "type": "vendor",
    "screen": "supplier",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Customers",
    "type": "vendor",
    "screen": "customer",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Process",
    "type": "part",
    "screen": "process",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Machines",
    "type": "part",
    "screen": "machines",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Parts",
    "type": "part",
    "screen": "parts",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Boughtouts",
    "type": "part",
    "screen": "boughtouts",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Assembly Settings",
    "type": "part",
    "screen": "assemblySettings",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Quotations",
    "type": "order",
    "screen": "quotations",
    "actions": [
      "view",
      "edit",
      "approve"
    ]
  },
  {
    "name": "Orders",
    "type": "order",
    "screen": "orders",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Assembly",
    "type": "order",
    "screen": "assembly",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Stores",
    "type": "home",
    "screen": "stores",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Attendance",
    "type": "home",
    "screen": "attendance",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Leave Request",
    "type": "home",
    "screen": "leave_request",
    "actions": [
      "view",
      "edit"
    ]
  },
  {
    "name": "Enquiry",
    "type": "home",
    "screen": "enquiry",
    "actions": [
      "view",
      "edit"
    ]
  }
]